


























































































































































































































import { Component, Vue, Prop, Watch, Ref } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import DataDokter from "@/services/DataUtility";
import DataSKDP from "@/services/DataSKDP";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storeSKDP } from "@/store/modules/skdp";
import { storeSoap } from "@/store/modules/soap";
import moment from "moment";
import TglKontrolSkdp from "@/components/form_components/TglKontrolSkdp.vue";

@Component({
  components: {
    CardModalTtd,
    TglKontrolSkdp
  },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CardModalSKDP extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() readonly register!: string;
  @Prop() dataSkdp!: string;
  @Prop() kronis!: string;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  checkKronis = false;
  dokter = {};
  diagnosis = "";
  alasan = "";
  rtl = "";
  tglRujukan = "";
  tglKontrol = "";
  sess_login = userModule.user;
  listDokter = {};
  alert = "";
  validasi = [v => !!v || "*Kolom ini harus diisi"];
  err = {};
  modalTtd = false;
  tglShowRujukan = false;
  tglShowKontrol = false;
  tglrekom = "";
  today = new Date().toISOString().substr(0, 10);
  maxKontrol = new Date().toISOString().substr(0, 10);
  dissableSunday = val => ![0].includes(new Date(val).getDay());
  functionEvents = null;
  searchAlasan = null;
  entriesAlasan = [];
  searchRtl = null;
  entriesRtl = [];
  autofocus = false;
  hintTglKontrol = "";
  loadingTglKontrol = false;

  get show() {
    // console.log(this.value);
    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }

  get stateInputSkdp() {
    return storeSKDP.inputSkdp;
  }
  get stateSkdp() {
    return storeSKDP.skdp;
  }

  get statesoapdetail() {
    return storeSoap.detailSoap;
  }

  mounted() {
    this.getDpjp();

    storeSKDP.act_autocomplete_alasan(this.searchAlasan);
    storeSKDP.act_autocomplete_rtl(this.searchRtl);
  }
  @Watch("dataSkdp")
  getSkdp() {
    // console.log(this.kronis);
    if (this.dataSkdp["dokter"] == undefined) {
      this.dokter = { id: this.sess_login.id, nama: this.sess_login.nama };
      this.diagnosis = this.statesoapdetail[0].a;
      this.alasan = "";
      this.rtl = "";
      this.tglRujukan = "";
      this.tglKontrol = "";
      if (this.kronis == "1") {
        this.checkKronis = true;
      } else {
        this.checkKronis = false;
      }
    } else {
      this.dokter = this.dataSkdp["dokter"];
      this.diagnosis = this.dataSkdp["diagnosis"];
      this.alasan = this.dataSkdp["alasan"];
      this.rtl = this.dataSkdp["rtl"];
      this.tglRujukan = this.dataSkdp["tgl_rujukan"];
      this.tglKontrol = this.dataSkdp["tgl_kunjungan"];
      this.checkKronis = this.dataSkdp["kasus_kronis"];
    }
  }

  passTtd(value) {
    this.$emit("passTtd", value);
    // this.modalTtd = false;
  }

  getDpjp() {
    const dktr = DataDokter.getListDokter();
    dktr.then(dktr => {
      this.listDokter = dktr;
    });
  }

  simpanSKDP() {
    if (this.readOnly) return;
    // const svSkdp = { ...this.stateInputSkdp };
    const id_dpjp = this.sess_login["id"];
    let kronis = "";
    if (this.checkKronis == true) {
      kronis = "1";
    } else {
      kronis = "0";
    }
    // if (
    //   this.diagnosis == "" ||
    //   this.alasan == "" ||
    //   this.rtl == "" ||
    //   // this.tglRujukan == "" ||
    //   this.tglKontrol == ""
    // ) {
    //   this.alert = "Kolom SKDP tidak boleh ada yang kosong";
    //   appModule.sendErrorAlert(this.alert);
    // } else {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      appModule.setLoading(true);
      if (this.dataSkdp["dokter"] == undefined) {
        // console.log("Simpan");
        const dt = DataSKDP.saveDataSKDP(
          this.register,
          this.dokter["id"],
          this.sess_login["unit_id"],
          this.tglRujukan,
          this.diagnosis,
          this.alasan,
          this.rtl,
          this.tglKontrol,
          this.sess_login["id"],
          kronis
        );
        dt.then(dt => {
          appModule.setLoading(false);
          if (dt["status"] != 1) {
            // appModule.sendErrorAlert(dt["err"]);
          } else {
            storeSKDP.actSkdp_on_reg(this.register);
            this.modalTtd = true;
            this.show = false;
            appModule.NoticeDelay("Berhasil Simpan SKDP");
          }
        });
      } else {
        // console.log("Edit");
        const dt = DataSKDP.changeDataSKDP(
          this.dataSkdp["id"],
          this.dataSkdp["register_id"],
          this.dokter["id"],
          this.sess_login["unit_id"],
          this.tglRujukan,
          this.diagnosis,
          this.alasan,
          this.rtl,
          this.tglKontrol,
          this.sess_login["id"],
          kronis
        );
        dt.then(dt => {
          appModule.setLoading(false);
          if (dt["status"] != 1) {
            // appModule.sendErrorAlert(dt["err"]);
          } else {
            storeSKDP.actSkdp_on_reg(this.register);
            this.modalTtd = true;
            this.show = false;
            appModule.NoticeDelay("Berhasil Ubah SKDP");
          }
        });
      }
    }
  }

  close() {
    storeSKDP.actSkdp_on_reg(this.register);
    this.show = false;
  }

  get tglRujukanFormattedMomentjs() {
    // return this.stateInputSkdp.tgl_rujukan
    //   ? moment(this.stateInputSkdp.tgl_rujukan).format("DD MMMM YYYY")
    //   : "";
    return this.tglRujukan
      ? moment(this.tglRujukan).format("DD MMMM YYYY")
      : "";
  }

  get tglKontrolFormattedMomentjs() {
    // return this.stateInputSkdp.tgl_kunjungan
    //   ? moment(this.stateInputSkdp.tgl_kunjungan).format("DD MMMM YYYY")
    //   : "";
    return this.tglKontrol
      ? moment(this.tglKontrol).format("DD MMMM YYYY")
      : "";
  }

  get stateAlasan() {
    return storeSKDP.alasan;
  }

  get stateRtl() {
    return storeSKDP.rtl;
  }

  @Watch("searchAlasan", { deep: true })
  searchedAlasan() {
    if (this.searchAlasan === null || this.searchAlasan.length < 2) return;
    if (this.alasan === this.searchAlasan) return;
    this.entriesAlasan = this.stateAlasan.map(alasan => {
      // console.log("alasan", alasan.text);
      return alasan.text;
    });
  }

  @Watch("searchRtl", { deep: true })
  searchedRtl() {
    if (this.searchRtl === null || this.searchRtl.length < 2) return;
    if (this.rtl === this.searchRtl) return;
    this.entriesRtl = this.stateRtl.map(rtl => {
      // console.log("alasan", alasan.text);
      return rtl.text;
    });
  }
  @Ref() readonly ttd!: HTMLElement;
  @Ref() readonly diag!: HTMLInputElement;

  setTglKontrol(val) {
    this.tglKontrol = val;
  }
}
